import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { type PartnerPickDeviceDatum } from 'domains/partner-pick-devices/types/partnerPickDevices.types'
import { useDomainMessage } from 'domains/partner-pick-devices/utils/domain/intl'
import { DeviceTypeEnum } from 'domains/partner-pick-devices/api'

interface Props {
  partnerPickDevice: PartnerPickDeviceDatum
}

export const PartnerPickDevicesListDeviceTypeCell: FunctionComponent<Props> = ({
  partnerPickDevice: { deviceType },
}) => {
  const deviceTypeString =
    deviceType === DeviceTypeEnum.Wifi
      ? 'partnerPickDevicesDomain.details.deviceType.wifi'
      : 'partnerPickDevicesDomain.details.deviceType.phone'

  return <Text>{useDomainMessage(deviceTypeString)}</Text>
}
